import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Clock, CheckCircle2, Dumbbell, Users } from 'lucide-react';
import { Button } from './Button';
import { FloatingDecorations } from './FloatingDecorations';
export function Hero() {
  return <section className="relative flex items-center pt-8 pb-12 overflow-hidden bg-gradient-to-b from-pastel-lavender/20 to-pastel-white" data-id="element-134">
      <FloatingDecorations data-id="element-135" />

      <div className="container mx-auto px-5 sm:px-8 lg:px-12 relative z-10" data-id="element-136">
        <div className="max-w-4xl mx-auto text-center" data-id="element-137">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-138">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-gray-900 leading-tight mb-8" data-id="element-139">
              Transformá el estrés y la ansiedad de tus hijos en{' '}
              <span className="text-gradient from-pastel-lavender-dark to-pastel-pink" data-id="element-140">
                calma en menos de 48h
              </span>
            </h1>
          </motion.div>

          {/* Mockup between headline and subheadline */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative z-10 flex justify-center mb-8" data-id="element-141">
            <div className="relative w-full max-w-xl" data-id="element-142">
              <div className="absolute inset-0 bg-gradient-to-tr from-pastel-lavender to-pastel-pink opacity-30 blur-3xl rounded-full transform scale-90" data-id="element-143"></div>
              <img src="https://cdn.magicpatterns.com/uploads/amLx6QYN2jXjdUpPNUj8SB/Untitled_design_(1).png" alt="Yoga Kids ELITE PRO KIT" className="relative z-10 w-full object-contain drop-shadow-2xl hover:-translate-y-2 transition-transform duration-500" data-id="element-144" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-145">
            <p className="text-base sm:text-lg text-gray-600 mb-8 max-w-xl mx-auto leading-relaxed" data-id="element-146">
              El método de yoga infantil que ya ayuda a cientos de familias a
              reducir pantallas y mejorar el descanso.
            </p>

            <div className="flex flex-col items-center gap-5" data-id="element-147">
              <Button href="#oferta" className="w-full sm:w-auto" data-id="element-148">
                QUIERO EL KIT COMPLETO
              </Button>

              <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm text-gray-500 font-medium" data-id="element-149">
                <div className="flex items-center gap-1" data-id="element-150">
                  <Clock size={16} className="text-pastel-mint" data-id="element-151" />
                  <span data-id="element-152">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-153">
                  <Shield size={16} className="text-pastel-aqua" data-id="element-154" />
                  <span data-id="element-155">Pago seguro</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-156">
                  <CheckCircle2 size={16} className="text-pastel-yellow" data-id="element-157" />
                  <span data-id="element-158">Garantía 7 días</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-159">
                  <Dumbbell size={16} className="text-pastel-pink" data-id="element-160" />
                  <span data-id="element-161">+100 ejercicios guiados</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-162">
                  <Users size={16} className="text-pastel-lavender-dark" data-id="element-163" />
                  <span data-id="element-164">Apto familia entera</span>
                </div>
              </div>

              {/* Audience badge moved here, between trust microcopy and social proof strip */}
              <span className="inline-block py-1.5 px-4 rounded-full bg-pastel-lavender/30 text-pastel-lavender-dark font-bold text-xs sm:text-sm uppercase tracking-wider mt-2" data-id="element-165">
                Para niños de 3 a 12 años y madres embarazadas
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}